// 歌曲播放模式
export const playMode = {
  sequence: 0, // 顺序
  loop: 1,     // 循环
  random: 2    // 随机
}
